const key = "veritrellis_workspace_id";

export const readWorkspaceIdFromSession = (): string | null => {
  const raw = globalThis.sessionStorage.getItem(key);
  if (typeof raw !== "string" || raw.length === 0) {
    return null;
  }
  return raw;
};

export const writeWorkspaceIdToSession = (workspaceId: string) => {
  globalThis.sessionStorage.setItem(key, workspaceId);
};

export const clearWorkspaceIdFromSession = () => {
  globalThis.sessionStorage.removeItem(key);
};
